"use client";

import { useMemo } from "react";
import { useLocation, useNavigate, Outlet } from "react-router-dom";
import { useSidebar } from "@speakai/ui/sidebar";
import { Menu } from "lucide-react";
import { BackIconButton } from "@/components/shared/page-header-with-back";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils/cn";
import { settingsMenuGroups } from "@/config/menu";

export function ProfileLayout() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { setMobileOpen } = useSidebar();

  const currentTitle = useMemo(() => {
    const item = settingsMenuGroups.flatMap((g) => g.items).find((i) => i.href === pathname);
    if (!item) return t("PROFILE.TITLE", "Profile");
    return t(item.labelKey, item.labelFallback);
  }, [pathname, t]);

  return (
    <div className="min-h-0">
      <div className="flex items-center gap-1 mb-4 md:hidden">
        <BackIconButton onClick={() => pathname === "/profile" ? navigate(-1) : navigate("/profile")} />
        <span className="min-w-0 flex-1 truncate text-sm font-medium text-foreground">{currentTitle}</span>
        <button
          type="button"
          onClick={() => setMobileOpen(true)}
          aria-label={t("PROFILE.ALL_SETTINGS_ARIA", "All settings")}
          className={cn(
            "inline-flex items-center gap-2 rounded-md border border-border px-3 py-1.5 text-sm text-muted-foreground",
            "hover:text-foreground hover:bg-accent transition-colors",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
          )}
        >
          <Menu className="h-4 w-4 shrink-0" />
          <span className="hidden sm:inline">{t("PROFILE.ALL_SETTINGS_ARIA", "All settings")}</span>
        </button>
      </div>

      <Outlet />
    </div>
  );
}
